import {Entity, repository} from 'aurelia-orm';

@repository(ThemeColor)
export class ThemeColor extends Entity {
    id: number;
    name: string;
    hex: string;
    themeId: number;
	themeColorTypeId: number;
	themeClass: string;
}